<template>
    <div>
        <!-- 助学专业 -->
        <el-table
            v-if="type === 'major'"
            :data="tableData"
            style="width: 100%"
            :cell-style="{
                'font-size': '16px',
                color: '#333',
            }"
            :header-cell-style="{
                'background-color': '#d7d7d7',
                'font-weight': '700',
                color: '#333',
                'font-size': '14px',
            }"
        >
            <el-table-column label="序号" align="center" header-align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.rowNum }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="班级编码"
                prop="classCode"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="班级名称"
                prop="albumTitle"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div style="color: #409eff; cursor: pointer" @click="handleSelected(scope.row)">
                        {{ scope.row.albumTitle }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="办学类型"
                prop="educationType"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{educationTypeList.find(v=>v.value===scope.row.educationType)?educationTypeList.find(v=>v.value===scope.row.educationType).label:''}}
              </template>
            </el-table-column>
            <el-table-column
                label="办学模式"
                prop="bxms"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{bxmsList.find(v=>v.value===scope.row.bxms)?bxmsList.find(v=>v.value===scope.row.bxms).label:''}}
              </template>
            </el-table-column>
            <el-table-column
                label="学习形式"
                prop="xxxs"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{xxxsList.find(v=>v.value===scope.row.xxxs)?xxxsList.find(v=>v.value===scope.row.xxxs).label:''}}
              </template>
            </el-table-column>
            <el-table-column
                label="合作院校"
                prop="schoolName"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="合作机构"
                prop="mhmName"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="年级"
                prop="gradeName"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="班级编号"
                prop="classNumber"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="班级人数"
                prop="studentCount"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div style="cursor: pointer; color: #d9001b">
                        {{ scope.row.studentCount }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="班级状态"
                prop="status"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div style="cursor: pointer; color: #d9001b">
                        {{ scope.row.status }}
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 合作院校、合作机构 -->
        <el-table
            v-else
            :data="tableData"
            style="width: 100%"
            :cell-style="{
                'font-size': '16px',
                color: '#333',
            }"
            :header-cell-style="{
                'background-color': '#d7d7d7',
                'font-weight': '700',
                color: '#333',
                'font-size': '16px',
            }"
        >
            <el-table-column label="序号" align="center" header-align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.$index + 1 }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="招生专业编码"
                prop="enrollMajorCode"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div style="color: #409eff">
                        {{ scope.row.enrollMajorCode }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="专业名称"
                prop="majorName"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="专业代码"
                prop="majorCode"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="建设主考学校代码"
                prop="mainSchoolCode"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="专业建设主考学校"
                prop="mainSchoolName"
                align="center"
                header-align="center"
            ></el-table-column>
            <!-- <el-table-column
                label="课程组件代码"
                prop="closeCount"
                align="center"
                header-align="center"
            ></el-table-column> -->
            <el-table-column
                label="课程组代码"
                prop="courseGroupCode"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="课程组名称"
                prop="courseGroupName"
                align="center"
                header-align="center"
            ></el-table-column>
             <el-table-column
                label="培养层次"
                prop="eduLevel"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                {{scope.row.eduLevel===3?'本科':scope.row.eduLevel===4?'专科':''}}
              </template>
            </el-table-column>
            <el-table-column
                label="授予学位"
                prop="degreeName"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="班级数"
                prop="albumCount"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="报名中"
                prop="signCount"
                align="center"
                header-align="center"
            ></el-table-column>
             <el-table-column
                label="学习中"
                prop="learningCount"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="未开班"
                prop="noLearnCount"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="已结课"
                prop="closeCount"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="在学人数"
                prop="stuLearnNum"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="学习总人数"
                prop="stuTotalNum"
                align="center"
                header-align="center"
            ></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: ["type", "tableData"],
    data(){
      return {
        educationTypeList:[
          {label:'自学考试',value:'1'},
          {label:'成人教育',value:'2'},
          {label:'网络教育',value:'3'},
          {label:'高端培训',value:'4'}
        ], // 办学类型
        bxmsList:[
          {label:'公开学院',value:'1'},
          {label:'相沟通',value:'2'},
          {label:'本科二学历',value:'3'},
          {label:'社会助学',value:'4'},
          {label:'主考专业',value:'4'}
        ], // 办学模式
         xxxsList:[
          {label:'业余',value:'1'},
          {label:'集中',value:'2'}
        ], // 学习形式
      }
    },
    methods: {
      /** 选择专业查看 */
      handleSelected(row){
        this.$emit('changes',row)
      }
    },
};
</script>

